if (typeof Swiper !== 'undefined') {
  new Swiper('.swiper-container', {
  preloadImages: false,
  lazy: {
    loadPrevNext: true,
  },
  autoplay: {
    delay: 4000,
  },
  loop: true,
  speed: 1500,
  disableOnInteraction: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  });
}
